<template>
  <v-menu
    ref="menu"
    v-model:model-value="isActive"
    location="bottom"
    :persistent="false"
    close-on-content-click
  >
    <template #activator="{ props }">
      <sf-icon-button :icon="mdiDotsVertical" v-bind="props" :aria-label="$t('openMenu')" />
    </template>
    <v-list :density="dense ? 'compact' : 'default'">
      <slot @save="close" />
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import SfIconButton from '@/components/button/SfIconButton.vue'
import { mdiDotsVertical } from '@mdi/js'
import { ref } from 'vue'

defineProps({
  dense: {
    type: Boolean,
    default: false
  }
})

const isActive = ref(false)

const close = () => {
  isActive.value = false
}

defineExpose({ close })
</script>
